import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import type { InformationCardProps } from './InformationCard.type';
import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { InformationFields } from './InformationFields';
import { Group } from '@folio/components/ui/flex';

export { resolveFieldShortcutFromConfig } from './InformationFields';

export const InformationCard = ({
  title,
  productId,
  fieldsConfig,
  entityType,
  entity,
  allowEdition = true,
  updateEntity,
  redirectToForm,
  headerActions,
}: InformationCardProps) => {
  const { policy } = usePolicyOnDashboard();

  return (
    <Card>
      <CardHeader>
        <Group justify="between" gap={0}>
          <CardTitle>{title}</CardTitle>
          {headerActions && <Group gap={2}>{headerActions}</Group>}
        </Group>
      </CardHeader>
      <CardContent>
        <InformationFields
          productId={productId}
          fieldsConfig={fieldsConfig}
          entityType={entityType}
          entity={entity}
          updateEntity={updateEntity}
          redirectToForm={redirectToForm}
          allowEdition={allowEdition}
          forceReadonly={policy?.status === 'POLICY_STOPPED'}
        />
      </CardContent>
    </Card>
  );
};
